import i18n from "../../../i18n";
import { Notification } from "../../../Utils/Notification";

export const toggleDialogs = (state, action) => {
  return {
    ...state, Dialogs: {
      ...state.Dialogs,
      [action.dialog]: action.state
    }
  };
};

export const clearState = (state, action, init) => {
  return {
    ...state, [action.state]: init[action.state]
  };
};

export const getAllHubs = (state, action) => {
  const updateValue = {
    request: action.data,
    response: action.data?.planId ? state.AllHubs.response : state.AllHubsTable.response,
    error: null,
  };
  if (action.data?.planId) {
    return { ...state, AllHubs: updateValue };
  } else {
    return { ...state, AllHubsTable: updateValue };
  }
};
export const getAllHubsSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity || [],
    error: null,
  };

  // Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, 'success');

  if (action.forMap) {
    return { ...state, AllHubs: updateValue };
  } else {
    return { ...state, AllHubsTable: updateValue };
  }
};
export const getAllHubsFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, AllHubs: updateValue, AllHubsTable: updateValue };
};

export const createHub = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, CreateHub: updateValue };
};
export const createHubSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, 'success');
  return { ...state, CreateHub: updateValue };
};
export const createHubFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error", 4000)
  return { ...state, CreateHub: updateValue };
};


export const editHub = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, EditHub: updateValue };
};
export const editHubSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, 'success');
  return { ...state, EditHub: updateValue };
};
export const editHubFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error", 4000)
  return { ...state, EditHub: updateValue };
};


export const deleteHub = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, DeleteHub: updateValue };
};
export const deleteHubSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, 'success');
  return { ...state, DeleteHub: updateValue };
};
export const deleteHubFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error", 4000)
  return { ...state, DeleteHub: updateValue };
};


export const getHubById = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, SingleHub: updateValue };
};
export const getHubByIdSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  return { ...state, SingleHub: updateValue };
};
export const getHubByIdFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error", 4000)
  return { ...state, SingleHub: updateValue };
};


export const assignPolygonToHub = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, AssignPolyToHub: updateValue };
};
export const assignPolygonToHubSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, 'success');
  return { ...state, AssignPolyToHub: updateValue };
};
export const assignPolygonToHubFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error", 4000)
  return { ...state, AssignPolyToHub: updateValue };
};


export const removeHubFromPolygon = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, RemoveHubPolygon: updateValue };
};
export const removeHubFromPolygonSuccess = (state, action) => {
  const updateValue = {
    request: null,
    response: action.res?.entity,
    error: null,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.res?.messageFa : action.res?.message, 'success');
  return { ...state, RemoveHubPolygon: updateValue };
};
export const removeHubFromPolygonFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error", 4000)
  return { ...state, RemoveHubPolygon: updateValue };
};